module.exports = __webpack_public_path__ + "static/img/mp4.eb6badd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons-actividad/mp4.png
// module id = 430
// module chunks = 1